// src/redux/mappers/Export/CreateNewJob/SezInfoMappers.js

// ✅ Map API response -> frontend object
export const mapSezinfoResponse = (data) => {
  if (!data) return null;

  return {
    id: data.exportSezId,
    exportMasterId: data.exportMasterId,
    submittedBy: data.submittedBy,
    sezUnitCode: data.sezUnitCode,
    drawbackBeneficiary: data.drawbackBeneficiary,
    status: data.exportSezStatus,
    entryDate: data.exportSEZEntryDate,
    updateDate: data.exportSEZUpdateDate,
    createdBy: data.sezCreatedBy,
    updatedBy: data.sezUpdatedBy,
  };
};

// utils/mappers.js (or wherever you keep helpers)
export const mapSezinfoRequest = (sezData) => {
  return {
    sez:sezData};
};

